import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import useIsMobileViewport from 'hooks/useIsMobileViewport.hook';
import { useTheme } from 'providers/Theme.provider';

import CN from './ReactivateFormModal.module.scss';

export const ReactivateFormModal = ({ isOpen, onClose, onConfirm, formName, ruleTags }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const isMobile = useIsMobileViewport();

  return (
    <SalonModal
      tag="ReactivateFormModal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onClose={onClose}
      fullWidth={!isMobile}
      mode="dark"
      customClass={cn(CN.modalDialog, { [CN.modalDialogDark]: isDarkMode })}
    >
      <SalonModal.Header>
        <div data-bem="ReactivateFormModal__header" className={cn(CN.modalHeader, { [CN.darkMode]: isDarkMode })}>
          <Button variant="icon" tag="ReactivateFormModal__close" className={CN.closeButton} onClick={onClose}>
            <Icon variant="closeDark" width="lg" />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={cn(CN.heading, { [CN.darkMode]: isDarkMode })}>
          <h2 className={CN.title}>{t('consultationForms.reactivateModal.title')}</h2>
          <p className={CN.message}>
            {t('consultationForms.reactivateModal.message')} <strong>&lsquo;{formName}&rsquo;</strong>?
          </p>
        </div>
        {ruleTags && ruleTags.length > 0 && (
          <>
            <p className={cn(CN.willSendWith, { [CN.darkMode]: isDarkMode })}>{t('consultationForms.reactivateModal.willSendWith')}</p>
            <ul data-bem="ReactivateFormModal__rulesList" className={cn(CN.rulesList, { [CN.darkMode]: isDarkMode })}>
              {ruleTags.map((ruleTag) => (
                <li key={`${ruleTag.category}-${ruleTag.label}`} className={CN.ruleRow}>
                  <span className={CN.ruleCategory}>{ruleTag.category}</span>
                  <span className={CN.ruleValue}>{ruleTag.label}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="tertiary" onClick={onClose} tag="ReactivateFormModal__cancel">
          {t('consultationForms.cancel')}
        </Button>
        <Button variant="primary" onClick={onConfirm} tag="ReactivateFormModal__confirm">
          {t('consultationForms.reactivateModal.confirm')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};
